import React, { Component } from 'react';
import GeneralPreference from './General/GeneralPreference';
import SalesOrderPreference from './SalesOrderPreference/SalesOrderPreference';
import PurchaseOrderPreference from './PurchaseOrderPreference/PurchaseOrderPreference';
import InvoicePreference from './InvoicePreference/InvoicePreference';
import BillPreference from './BillPreference/BillPreference';
import SaleReturnPolicyPreference from './SaleReturnPolicyPreference/SaleReturnPolicyPreference';
import PrintandPdfPreference from './PrintandPdfPreference/PrintandPdfPreference';
import DashboardPrefrences from './DashboardPrefrences/DashboardPrefrences';
import EmailPrefrence from './EmailPreference/EmailPrefrence';
import Layout, { Header, Body } from '../../Components/Layout/Layout';
import NavLayout from '../../Components/Layout/NavLayout';
import './Preference.css';
import Prefix from './Prefix/Prefix';
import { t } from 'i18next';

class Preference extends Component {
  routes = [
    {
      title: t('Settings.general'),
      path: '/preference',
      component: GeneralPreference,
    },
    {
      title: t('Settings.sales_order'),
      path: '/preference/salesorder',
      component: SalesOrderPreference,
    },
    {
      title: t('Settings.invoice'),
      path: '/preference/invoice',
      component: InvoicePreference,
    },
    {
      title: t('Settings.purchase_order'),
      path: '/preference/purchaseorder',
      component: PurchaseOrderPreference,
    },
    {
      title: t('Settings.bill'),
      path: '/preference/bill',
      component: BillPreference,
    },
    {
      title: t('Settings.credit_note_deduction_policy'),
      path: '/preference/SaleReturnPolicyPreference',
      component: SaleReturnPolicyPreference,
    },
    {
      title: t('Settings.prefixes'),
      path: '/preference/Prefix',
      component: Prefix,
    },
    {
      title: t('common.prints_and_pdf'),
      path: '/preference/pdfandprint',
      component: PrintandPdfPreference,
    },
    {
      title: t('Settings.dashboard'),
      path: '/preference/dashboard',
      component: DashboardPrefrences,
    },
    {
      title: t('common.email'),
      path: '/preference/email',
      component: EmailPrefrence,
    },
  ];

  componentDidMount() {
    document.title = 'Preferences';
  }

  renderPreference() {
    return (
      <div className="preference">
        <NavLayout routes={this.routes} handleToast={this.props.handleToast} />
      </div>
    );
  }

  render() {
    return (
      <Layout>
        <Header title={t('Settings.preferences')}></Header>
        <Body>{this.renderPreference()}</Body>
      </Layout>
    );
  }
}

export default Preference;
